export const TYPE_LOCAL = 1;
export const TYPE_WEBSHOP = 2;

/**
 * @param {Object} company
 * @param {number} type
 * @returns {boolean}
 */
function hasCompanyType(company, type) {
    if (company.types === undefined || !Array.isArray(company.types)) {
        return false;
    }

    return Boolean(company.types.find(company_type => {
        return company_type.id === type;
    }));
}

/**
 * @param {Object} company
 * @returns {boolean}
 */
export function hasLocalCompany(company) {
    return hasCompanyType(company, TYPE_LOCAL);
}
